import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const postIdResolver: FieldResolver = (metadata: Metadata) =>
  ({ postId: metadata.getPostId() } as StreamData)

export default postIdResolver
